module.exports = __webpack_public_path__ + "img/ball_5.b264e0fd.png";